export default __webpack_public_path__ + "static/media/BlogImageOne.d4650565.jpeg";